export const cartPromoBox = {
  title: 'Have you tried our latest?',
  subtitle: 'Hydration drops',
  description:
    'Formulated with 100% natural active ingredients and compatible with contact lenses.',
  imageUrl: '/images/hydration-drops-white-bg.png',
  buttonText: 'Add to cart for $13.00',
};
